import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetProductsCategories as GetProductsCategoriesQuery,
    GetProductsCategories_productCategories as ProductCategory,
} from 'nutshell-graphql-types';

import GET_PRODUCTS_CATEGORIES from '../queries/get-product-categories.graphql';

export const useGetProductCategories = (): {
    productCategories: Array<ProductCategory>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {loading, data, error} = useQuery<GetProductsCategoriesQuery, Record<any, any>>(
        GET_PRODUCTS_CATEGORIES,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        productCategories: data && data.productCategories ? data.productCategories : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
